
































































import Vue from "vue";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { Order } from "../models/Order";
export default Vue.extend({
  mixins: [pagination, dialog],
  data() {
    const orders: Order[] = [];
    return {
      orders
    };
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getHoldOrder()]);
  },
  methods: {
    async getHoldOrder() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.orderUseCase.getHoldOrders(form);
        this.orders = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    async reverseHoldStatus(order: Order) {
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to reverse hold order" + order.mcNumber,
        "คุณต้องการคืนสถานะ hold order: " + order.mcNumber + " หรือไม่ ?"
      );
      if (isConfirmed) {
        try {
          await (this as any).$dep.orderUseCase.reverseHoldOrderById(order.id);
          (this as any).alertSuccess("Success", "Reverse Hold Order สำเร็จ");
          window.location.reload();
        } catch (error) {
          if (error.response.data.message) {
            (this as any).alertError("Error", error.response.data.message);
          } else {
            (this as any).alertError("Error", error);
          }
        }
      }
    },
    async cancelHoldStatus(order: Order) {
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to cancel hold order" + order.mcNumber,
        "คุณต้องการยกเลิก hold order: " + order.mcNumber + " หรือไม่ ?"
      );
      if (isConfirmed) {
        try {
          await (this as any).$dep.orderUseCase.cancelHoldOrderById(order.id);
          (this as any).alertSuccess("Success", "Cancel Hold Order สำเร็จ");
          window.location.reload();
        } catch (error) {
          if (error.response.data.message) {
            (this as any).alertError("Error", error.response.data.message);
          } else {
            (this as any).alertError("Error", error);
          }
        }
      }
    }
  }
});
